var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.636,
    height: 12.571,
    viewBox: "0 0 12.636 12.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit_5_",
    "data-name": "edit (5)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6123",
    "data-name": "Path 6123",
    d: "M304.862,10.941a1.1,1.1,0,0,1,0,1.557l-.556.556-1.927-1.927.556-.556a1.1,1.1,0,0,1,1.558,0Zm0,0",
    transform: "translate(-292.863 -9.935)",
    fill: "#00acea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6124",
    "data-name": "Path 6124",
    d: "M149.186,40.107l-5.04,5.04h0l-1.927-1.927,5.04-5.04Zm0,0",
    transform: "translate(-137.743 -36.987)",
    fill: "#00efd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6125",
    "data-name": "Path 6125",
    d: "M118.948,198.34l1.927,1.927-.018.018-2.665.738.738-2.665Zm0,0",
    transform: "translate(-114.472 -192.107)",
    fill: "#fedb41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6126",
    "data-name": "Path 6126",
    d: "M11.662,45.825a.315.315,0,0,0-.315.315v2.794a.945.945,0,0,1-.944.944H1.573a.945.945,0,0,1-.944-.944v-8.2a.945.945,0,0,1,.944-.944H4.368a.315.315,0,0,0,0-.629H1.573A1.575,1.575,0,0,0,0,40.734v8.2a1.575,1.575,0,0,0,1.573,1.573H10.4a1.575,1.575,0,0,0,1.573-1.573V46.14A.315.315,0,0,0,11.662,45.825Zm0,0",
    transform: "translate(0 -37.936)",
    fill: "#083863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6127",
    "data-name": "Path 6127",
    d: "M116.638.684a1.418,1.418,0,0,0-2,0L109.021,6.3a.316.316,0,0,0-.081.138L108.2,9.1a.315.315,0,0,0,.387.387l2.665-.738a.315.315,0,0,0,.139-.081l.018-.018,5.6-5.6a1.416,1.416,0,0,0,0-2ZM109.41,7.1l1.184,1.184-1.637.454Zm1.778,1.333h0l.205.205Zm0-.445L109.706,6.5l4.6-4.6,1.482,1.482Zm5.374-5.374-.334.334-1.482-1.482.334-.334a.788.788,0,0,1,1.113,0l.369.37a.786.786,0,0,1,0,1.112Zm0,0",
    transform: "translate(-104.786 -0.27)",
    fill: "#083863"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit5);
export default __webpack_public_path__ + "static/media/edit (5).04109164112e06401bbbfeadf1c6dc77.svg";
export { ForwardRef as ReactComponent };